document.addEventListener('DOMContentLoaded', () => {
	var personLinks = document.querySelectorAll('.person .person__link');
	const contactLinks = document.querySelectorAll('.contact__link');
	personLinks = [...personLinks, ...contactLinks];
	personLinks.forEach((personLink) => {
		var svg = personLink.querySelector('svg');
		if (svg) {
			svg.addEventListener('click', () => {
				a.click();
			});
		}
		var a = personLink.querySelector('a');
		a.addEventListener('click', (e) => {
			if (a.getAttribute('href') == '#') {
				e.preventDefault();
				a.setAttribute('href', personLink.getAttribute('data-href'));
				a.innerHTML = personLink.getAttribute('data-name');
				// Tutaj konwersja odsłonięcia numeru telefonu/email
				return;
			}
			//tutaj konwersja kliknięcia w odsłonięty link
		});
	});
});
